import { EnvironmentType } from '@careerhub/common';
import {
  FeedbackAuthenticationType,
  FeedbackPolicyValue,
  FeedbackScreenshotSourceType,
  FeedbackUiType,
  IFeedbackComplianceChecks,
  IFeedbackInitOptions,
} from '@ms/inapp-feedback-loader';

export const FeedbackOptions: IFeedbackInitOptions = {
  appId: __OCV__,
  authenticationType: FeedbackAuthenticationType.AAD,
  tenantId: __TENANT_ID__,
  isProduction: __ENVIRONMENT__ === EnvironmentType.Production,
  feedbackConfig: {
    isDisplayed: false,
    feedbackUiType: FeedbackUiType.Modal,
    isScreenshotEnabled: true,
    screenshotInfo: {
      providedScreenshotType: FeedbackScreenshotSourceType.AutoCaptureWithHtml2Canvas,
    },
    isEmailCollectionEnabled: true,
    complianceChecks: {
      connectedExperiences: FeedbackPolicyValue.NotConfigured,
      policyAllowFeedback: FeedbackPolicyValue.Enabled,
      policyAllowSurvey: FeedbackPolicyValue.Disabled,
      policyAllowScreenshot: FeedbackPolicyValue.Enabled,
      policyAllowContact: FeedbackPolicyValue.Enabled,
      policyAllowContent: FeedbackPolicyValue.Disabled,
      policyEmailCollectionDefault: FeedbackPolicyValue.Enabled,
      policyScreenshotDefault: FeedbackPolicyValue.Enabled,
      policyContentSamplesDefault: FeedbackPolicyValue.Disabled,
      // Required by the runtime bundle for AAD auth, not yet in type definitions
      policyAllowLimitedFeedback: FeedbackPolicyValue.Enabled,
    } as IFeedbackComplianceChecks,
  },
  themeOptions: { baseTheme: 'FabricDefaultTheme' },
};
